const KEY = "amalfi_consent";
const MAX_AGE = 182 * 86400000;
export const CATEGORIES = [
  { key: "necessary", label: "Strettamente necessari", desc: "Lingua scelta, sessione dell'area riservata, memoria di questa scelta. Sempre attivi.", label_en: "Strictly necessary", desc_en: "Chosen language, private-area session, memory of this choice. Always on.", locked: true },
  { key: "maps", label: "Mappe di terze parti (Google Maps, OpenStreetMap)", desc: "Mostra le mappe integrate: il fornitore della mappa riceve l'indirizzo IP e Google può impostare propri cookie. Senza consenso viene mostrato solo un link.", label_en: "Third-party maps (Google Maps, OpenStreetMap)", desc_en: "Shows embedded maps: the map provider receives your IP address and Google may set its own cookies. Without consent only a link is shown." },
];

export function getConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c && c.v === 1 && Date.now() - (c.at || c.ts) < MAX_AGE ? c : null;
  } catch { return null; }
}

export function saveConsent(choice) {
  const prev = getConsent() || {};
  const now = Date.now();
  const c = { v: 1, at: now, ts: now, maps: !!choice.maps, stats: !!prev.stats, rec: !!prev.rec };
  localStorage.setItem(KEY, JSON.stringify(c));
  window.dispatchEvent(new CustomEvent("amalfi-consent", { detail: c }));
  return c;
}

export const LEGACY_PATHS = /^\/(hotel|stazione|sito|destinazioni|q|guida)(\/|$)/;
export const openConsent = () => (LEGACY_PATHS.test(window.location.pathname) && window.amalfiConsentOpen ? window.amalfiConsentOpen() : window.dispatchEvent(new Event("amalfi-consent-open")));
